import { t } from '@hefe/i18n';
import { Inventory, RequestBasePostInventoryTransfer } from '@hefe/models';
import { BasketballUsersSlice, InventoryApi } from '@hefe/store';
import { Modal } from 'antd';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../store/store';
import CustomForm from '../../../core/components/form/custom-form';

interface CreateInventoryTransferFormProps {
  inventory: Inventory;
  open?: boolean;
  setOpen: (open: boolean) => void;
}

export default function CreateInventoryTransferForm(
  props: CreateInventoryTransferFormProps
) {
  const { inventory } = props;

  const dispatch = useAppDispatch();

  const [open, setOpen] = useState(props.open);
  const [saving, setSaving] = useState(false);

  const [createTransfer] = InventoryApi.useCreateTransferMutation();

  const usersSelect = useSelector(
    BasketballUsersSlice.basketballUsersSelectSelector
  );

  useEffect(() => {
    fetchUsersSelect();
  }, []);

  useEffect(() => {
    setOpen(props.open ?? false);
  }, [props.open]);

  useEffect(() => {
    props.setOpen(open ?? false);
  }, [open]);

  const fetchUsersSelect = () => {
    dispatch(
      BasketballUsersSlice.fetchBasketballUsersSelect({
        cacheDuration: 5 * 60 * 1000,
      })
    );
  };

  const onSubmit = (values: any, resetForm: any) => {
    const request: RequestBasePostInventoryTransfer = {
      inventory_id: inventory.id,
      to_user_id: values.user_id,
      comment: values.comment,
    };

    setSaving(true);
    createTransfer(request)
      .unwrap()
      .then(() => {
        setOpen(false);
        resetForm();
      })
      .catch(() => null)
      .finally(() => {
        setSaving(false);
      });
  };

  return (
    <Modal
      open={open}
      footer={null}
      closable
      zIndex={1000}
      bodyProps={{
        style: { paddingTop: 50 },
      }}
      onCancel={() => setOpen(false)}
    >
      <CustomForm
        key={`create-inventory-transfer-form-new`}
        //formId={`create-inventory-transfer-form-new`}
        fields={[
          {
            name: 'user_id',
            label: t('inventory.transfers.attributes.to_user'),
            type: 'select',
            selectOptions: usersSelect,
            rules: [
              {
                required: true,
                message: t('form_errors.name'),
              },
            ],
          },
          {
            name: 'comment',
            label: t('inventory.transfers.attributes.comment'),
            type: 'text',
            rules: [],
          },
        ]}
        loading={saving}
        onSubmit={onSubmit}
      />
    </Modal>
  );
}
